import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle } from "lucide-react";
import { unsubscribeNewsletter } from "../lib/api";
import { useT } from "../i18n/I18nProvider";

export default function Unsubscribe() {
  const { t, lp } = useT();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    unsubscribeNewsletter(token).then(() => setState("done")).catch(() => setState("error"));
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="unsubscribe-page">
      {state === "done" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500" />
          <h1 className="font-display text-3xl font-semibold mt-6">{t("confirm.unsubTitle")}</h1>
          <p className="text-slate-600 mt-3">{t("confirm.unsubBody")}</p>
          <Link to={lp("/")} className="hej-btn-primary inline-flex mt-8">{t("confirm.home")}</Link>
        </>
      )}
      {state === "error" && (
        <>
          <AlertCircle className="w-16 h-16 mx-auto text-[#DC143C]" />
          <h1 className="font-display text-3xl font-semibold mt-6">{t("confirm.invalidTitle")}</h1>
          <Link to={lp("/")} className="hej-btn-primary inline-flex mt-8">{t("confirm.home")}</Link>
        </>
      )}
      {state === "loading" && <p className="text-slate-500">{t("confirm.unsubLoading")}</p>}
    </div>
  );
}
